import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const StyledActionTypeTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
`;

export const StyledContainerGrid = styled(Grid)`
  justify-content: space-between;
  word-break: break-word;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }
`;

export const StyledChangeContainerDiv = styled('div')`
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const StyledGroupContainerDiv = styled('div')`
  &:not(:first-of-type) {
    margin-top: ${({ theme }) => theme.spacing(4)};
  }
`;

export const StyledGroupTitleTypography = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
`;

export const StyledLabelTypography = styled(Typography)`
  line-height: 16px;
  margin-bottom: ${({ theme }) => theme.spacing(0.75)};
` as typeof Typography;

export const StyledMetaSectionGrid = styled(Grid, { shouldForwardProp: prop => prop !== 'isDrawerMode' })<{
  isDrawerMode?: boolean;
}>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin: ${({ theme }) => theme.spacing(0, 2, 0, -1.5)};
  min-width: 200px;
  padding-left: ${({ theme, isDrawerMode }) => (isDrawerMode ? 0 : theme.spacing(4))};

  & > * {
    margin: ${({ theme }) => theme.spacing(0, 0, 0.5, 1.5)} !important;
  }
`;

export const StyledWhoTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
`;
